import { WabunkaConsumerCode } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_code';

import { useFetchToPublicWabunkaApi } from '@/wabunka-src/common/composables/query/useFetchToPublicWabunkaApi';

export const useCheckCodeUsability = async (codeName: string, email: string) => {
  const path = ref(`/codes/${codeName}/check`);
  const { data, error } = await useFetchToPublicWabunkaApi({
    path,
    body: ref({ email }),
    method: ref('POST'),
    options: { server: false },
    converter: WabunkaConsumerCode.fromJSON,
  });

  return { data, error };
};
